import { MentionTypes } from '@lyearn/lygo-blocks';
import contentConfig from '@/modules/content/config';
import useContents from '@/modules/corporate/modules/admin/hooks/useContents';
import { ContentEntity, MentionEntityTypeEnum } from '@/types/schema';

import { ALLOWED_CONTENT_STATUS, ALLOWED_CONTENT_TYPES } from '../../consts';
import { MentionsData } from '../../types';
import BaseContentItem from './BaseContentItem';

const useContentSearch = ({ searchString }: { searchString?: string }) => {
  const { contents, isFetching } = useContents({
    filters: {
      name: searchString,
      types: ALLOWED_CONTENT_TYPES,
      status: ALLOWED_CONTENT_STATUS,
    },
  });

  return { data: contents, fetching: isFetching };
};

const ContentMention = {
  getMentionNodeAttrs: (item: ContentEntity) => ({
    href: contentConfig[item.type].routes.details(item.id),
    name: item.name,
    id: item.id,
    type: MentionTypes.Content,
  }),
  useSearch: useContentSearch,
  getInitialItems: (items?: MentionsData) => items?.contents,
  BaseItem: BaseContentItem,
  type: MentionEntityTypeEnum.Content,
};

export default ContentMention;
